import React from "react";
import { useIntl } from "react-intl";
import Button from "../../overrides/venia-ui/components/Button";
export var ConsentSaveFeedback = _ref => {
  var {
    context,
    retryConsents,
    continueWithoutConsents,
    isSavingConsents,
    canContinueWithoutConsents = true
  } = _ref;
  var {
    formatMessage
  } = useIntl();
  return /*#__PURE__*/React.createElement("div", {
    className: "uk-margin",
    role: "status",
    "aria-live": "polite"
  }, /*#__PURE__*/React.createElement("p", null, formatMessage({
    id: "consents.capture.".concat(context, ".failed")
  })), /*#__PURE__*/React.createElement(Button, {
    type: "button",
    color: "miscusi_red",
    onClick: retryConsents,
    disabled: isSavingConsents
  }, formatMessage({
    id: "consents.page.retry"
  })), canContinueWithoutConsents ? /*#__PURE__*/React.createElement(Button, {
    type: "button",
    onClick: continueWithoutConsents,
    disabled: isSavingConsents
  }, formatMessage({
    id: "consents.capture.continue"
  })) : null);
};